module.exports = __webpack_public_path__ + "static/img/office_05.bcb4934.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/office_05.png
// module id = UBKm
// module chunks = 0